export default function timestampToDate(timestamp) {
  return new Date(timestamp);
}



// WEBPACK FOOTER //
// ./src/tools/timestampToDate.js